import { render, staticRenderFns } from "./Devir.vue?vue&type=template&id=106f43d3&"
import script from "./Devir.vue?vue&type=script&lang=js&"
export * from "./Devir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports